import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';

import { COLOR_CHECKBOX_NOT_ACTIVE } from 'constants/ColorVariable';
import { COLOR_CHECKBOX_CUSTOM } from 'constants/ColorVariable';
import * as Constants from './../../constants/index.js';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';

function RadioComponent({ control, radioList, defaultValue, name, setValue, handleChange, isHaveAll }) {
  const { t } = useTranslation();

  return (
    <Controller
      render={({ field }) => (
        <RadioGroup {...field} value={`${defaultValue}`}>
          {isHaveAll && (
            <FormControlLabel
              value=""
              onChange={(e) => {
                setValue(name, e.target.value);
                handleChange(e);
              }}
              control={
                <Radio
                  sx={{
                    color: COLOR_CHECKBOX_NOT_ACTIVE,
                    '&.Mui-checked': {
                      color: COLOR_CHECKBOX_CUSTOM,
                    },
                  }}
                />
              }
              label={t('employees.all')}
            />
          )}

          {radioList?.map((item, index) => (
            <div key={index} className={styles.division}>
              <FormControlLabel
                value={item?.id}
                onChange={(e) => {
                  setValue(name, e.target.value);
                  handleChange(e);
                }}
                control={
                  <Radio
                    sx={{
                      color: COLOR_CHECKBOX_NOT_ACTIVE,
                      '&.Mui-checked': {
                        color: COLOR_CHECKBOX_CUSTOM,
                      },
                    }}
                  />
                }
                label={item?.name}
              />
              {item?.value !== Constants.ALL && (
                <span className={styles.total}>{item.total_member ? item?.total_member : 0}</span>
              )}
            </div>
          ))}
        </RadioGroup>
      )}
      name={name}
      control={control}
      value={`${defaultValue}`}
    />
  );
}

export default RadioComponent;
